import axios from "@/api/index";
let method = 'GET';
/*首页添加视频播放次数*/
export const addVideoPlays=data=>axios.post('/versions/dynamic/addVideoPlays',data)
/*文章视频删除*/
export const articleDel=data=>axios.post('/versions/dynamic/articleDel',data)
/*文章/视频的点赞*/
export const articleFabulous=data=>axios.post('/versions/dynamic/articleFabulous',data)
/*文章/视频详情*/
export const articleInfo=data=>axios.post('/versions/dynamic/articleInfo',data)
/*文章详情中的相关推荐*/
export const articleInfoRecommend=data=>axios.post('/versions/dynamic/articleInfoRecommend',data)
/*消息模块 点赞列表*/
export const articleLikeList=data=>axios.post('/versions/dynamic/articleLikeList',data)
/*保存动态*/
export const articleSave=data=>axios.post('/versions/dynamic/articleSave',data)
/*保存动态内容*/
export const articleSaveDynamic=data=>axios.post('/versions/dynamic/articleSaveDynamic',data)
/*保存文章内容*/
export const articleSaveNews=data=>axios.post('/versions/dynamic/articleSaveNews',data)
/*保存视频内容*/
export const articleSaveVideo=data=>axios.post('/versions/dynamic/articleSaveVideo',data)
/*消息模块-- @我的 动态列表*/
export const atMeDynamicList=data=>axios.post('/versions/dynamic/atMeDynamicList',data)
/*招投标详情*/
export const biddingInfo=data=>axios.post('/versions/dynamic/biddingInfo',data)
/*文章/视频拉黑作者*/
export const blacklist=data=>axios.post('/versions/dynamic/blacklist',data)
/*文章/视频发表评论*/
export const commentAdd=data=>axios.post('/versions/dynamic/commentAdd',data)
/*文章/视频收藏*/
export const commentCollection=data=>axios.post('/versions/dynamic/commentCollection',data)
/*文章/视频删除评论*/
export const commentDel=data=>axios.post('/versions/dynamic/commentDel',data)
/*文章/视频评论的点赞*/
export const commentFabulous=data=>axios.post('/versions/dynamic/commentFabulous',data)
/*文章/视频评论列表*/
export const commentNewList=data=>axios.post('/versions/dynamic/commentNewList',data)
/*渝商列表*/
export const commercialLists=data=>axios.post('/versions/dynamic/commercialLists',data)
/*发布动态*/
export const complete=data=>axios.post('/versions/dynamic/complete',data)
/*企业服务网根据域名前缀获取某个省市区的配置*/
export const domainInfo=data=>axios.get('/versions/dynamic/domainInfo',data)
/*草稿详情*/
export const draftDetails=data=>axios.post('/versions/dynamic/draftDetails',data)
/*关注用户*/
export const editFollow=data=>axios.post('/versions/dynamic/editFollow',data)
/*粉丝列表*/
export const fensList=data=>axios.post('/versions/dynamic/fensList',data)
/*粉丝列表分页*/
export const fensListPage=data=>axios.post('/versions/dynamic/fensListPage',data)
/*关注的文章列表*/
export const focusNewsArticle=data=>axios.post('/versions/dynamic/focusNewsArticle',data)
/*关注列表*/
export const followList=data=>axios.post('/versions/dynamic/followList',data)
/*文章转发*/
export const forwardTotals=data=>axios.post('/versions/dynamic/forwardTotals',data)
/*切换节点*/
export const getRegionNew=data=>axios.get('/versions/dynamic/getRegionNew',data)
/*文章分类*/
export const headlines=data=>axios.post('/versions/dynamic/headlines',data)
/*本地招投标列表*/
export const locationBiddingPaging=data=>axios.post('/versions/dynamic/locationBiddingPaging',data)
/*本地招投标发布时间*/
export const locationBiddingTime=data=>axios.post('/versions/dynamic/locationBiddingTime',data)
/*本地动态列表*/
export const locationHotspot=data=>axios.post('/versions/dynamic/locationHotspot',data)
/*本地政策头条列表*/
export const locationPolicy=data=>axios.post('/versions/dynamic/locationPolicy',data)
/*企业微官网动态*/
export const microArticleLists=data=>axios.post('/versions/dynamic/microArticleLists',data)
/*消息模块 文章/视频评论列表*/
export const msgModuleCommentList=data=>axios.post('/versions/dynamic/msgModuleCommentList',data)
/*官方号文章列表*/
export const officialNumberArticleList=data=>axios.post('/versions/dynamic/officialNumberArticleList',data)
/*官方号列表*/
export const officialNumberList=data=>axios.post('/versions/dynamic/officialNumberList',data)
/*个人中心*/
export const personal=data=>axios.post('/versions/dynamic/personal',data)
/*个人中心文章列表*/
export const personalArticleLists=data=>axios.post('/versions/dynamic/personalArticleLists',data)
/*政策详情*/
export const policyInfo=data=>axios.post('/versions/dynamic/policyInfo',data)
/*推荐及其他分类下的文章列表*/
export const recommendLists=data=>axios.post('/versions/dynamic/recommendLists',data)
/*文章/视频举报*/
export const report=data=>axios.post('/versions/dynamic/report',data)
/*搜索列表中的文章视频举报*/
export const reportForSearch=data=>axios.post('/versions/dynamic/reportForSearch',data)
/*举报类型*/
export const reportType=data=>axios.get('/versions/dynamic/reportType',data)
/*所搜分类*/
export const searchCategory=data=>axios.get('/versions/dynamic/searchCategory',data)
/*帮企网首页搜索*/
export const searchSmeList=data=>axios.post('/versions/dynamic/searchSmeList',data)
/*文章/视频屏蔽*/
export const shield=data=>axios.post('/versions/dynamic/shield',data)
/*发布去向/同步类型*/
export const synchronizeToWhere=data=>axios.post('/versions/dynamic/synchronizeToWhere',data)
/*用户视频数量统计*/
export const videoTotals=data=>axios.post('/versions/dynamic/videoTotals',data)
/*用户视频数量统计*/
export const homepageComponentRest=data=>axios.post('/versions/microOfficial/homepageComponentRest',data)
/*定位获取位置信息*/
export function getCityInfo(lng,lat,level) {
    return axios.get("https://bqwapi.bangqichat.com/versions/dynamic/getCityInfo?lng="+lng+'&lat='+lat+'&level='+level)
}
/*店铺关注列表*/
export const shopArticleList=data=>axios.post('/home/rest/RevisionOnePersonalCenter/shopArticleList',data)
/*取消商品收藏/取消店铺关注*/
export const removeCollect=data=>axios.post('/home/rest/RevisionOneGoods/removeCollect',data)
/*各状态优惠券列表*/
export const couponsAvailableList=data=>axios.post('/order/personalCenter/couponsAvailableList',data)
/*服务收藏列表*/
export const serviceCollectionList=data=>axios.post('/home/rest/RevisionOnePersonalCenter/serviceCollectionList',data)
/*资讯收藏列表*/
export const collection=data=>axios.post('/home/rest/RevisionOnePersonalCenter/collection',data)
/*资讯收藏列表删除*/
export const collectionDel=data=>axios.post('/home/rest/RevisionOnePersonalCenter/collectionDel',data)
/*资讯收藏列表全部删除*/
export const collectionEmpty=data=>axios.post('/home/rest/RevisionOnePersonalCenter/collectionEmpty',data)
/*经营工具--招聘职位列表*/
export const homepageJobListings=data=>axios.post('/versions/cloudOfficialWebsitePC/homepageJobListings',data)
export function geocode(data){
    return axios.get("http://restapi.amap.com/v3/geocode/regeo?location="+data.location+'&key='+data.key)
}